export default __webpack_public_path__ + "static/media/logo-icon-color-rec-x.cd3409e6.svg";